<template>
  <div class="hero-body is-block">
    <div class="container">
      <div class="columns">

        <!-- Main content -->
        <div class="column is-12">  

          <div class="steps is-medium" id="create-steps">
            
            <div class="step-item"
                 :class="{'is-active': currentStepNum >= 0,
                          'is-completed': currentStepNum > 0}">
              <div class="step-marker">                
                  <span class="icon"
                        @click="currentStep = steps[0]">
                    <i class="fa fa-cloud-upload"></i>
                  </span>                
              </div>
              <div class="step-details">
                <p class="step-title">Upload</p>
                <p>Choose your .pptx file for conversion</p>
              </div>
            </div>

            <div class="step-item"
                 :class="{'is-active': currentStepNum >= 1,
                          'is-completed': currentStepNum > 1}">
              <div class="step-marker">                
                <span class="icon"
                      @click="currentStep = steps[1]">                  
                  <i class="fa fa-pencil"></i>
                </span>                                
              </div>
              <div class="step-details">
                <p class="step-title">Edit</p>
                <p>Make your changes to the draft sequence</p>
              </div>
            </div>

            <div class="step-item"
                 :class="{'is-active': currentStepNum >= 2,
                          'is-completed': currentStepNum > 2}">
              <div class="step-marker">
                <span class="icon"
                      @click="currentStep = steps[2]">
                  <i class="fa fa-twitter"></i>
                </span>
              </div>
              <div class="step-details">
                <p class="step-title">Tweet</p>
                <p>Send the sequence to Twitter</p>
              </div>
            </div>

          </div>

          <upload-section v-if="currentStep === steps[0]"
                          @upload-success="goToEditStep"></upload-section>

          <edit-section v-if="currentStep === steps[1]"
                        :slide-sequence="slideSequence"
                        @next="goToTweetStep"
                        @cancel="goToUploadStep"></edit-section>

          <tweet-section v-if="currentStep === steps[2]"
                         :tweet-sequence="tweetSequence"
                         @back-to-upload="goToUploadStep"></tweet-section>

        </div>

      </div>
    </div>
  </div>
</template>

<script>
import UploadSection from './create/UploadSection.vue';
import EditSection from './create/EditSection.vue';
import TweetSection from './create/TweetSection.vue';

import CreateBase from './CreateBase.vue';

// import * as _uploadResponse from './create/mock-response.json';
// import * as _mockUploadSequence from './create/mock-upload-sequence.json';

export default {
  name: "Create",

  extends: CreateBase,

  components: {
    UploadSection,
    EditSection,
    TweetSection
  },

  data: function() {
    return {

    };
  },

  computed: {

  },

  methods: {
    
  },

  mounted() {
    // TODO: Remove after testing
    // this.goToEditStep(_uploadResponse);    
    // this.goToTweetStep(_mockUploadSequence);
  }
};
</script>

<style lang="scss" scoped>
@import "~bulma/sass/utilities/_all";
// @import "~bulma-extensions/extensions";
@import "~bulma-extensions/bulma-steps/steps.sass";
</style>



// WEBPACK FOOTER //
// src/components/Create.vue